import React from 'react';
import {Box, Heading, Spinner} from '@spothero/ui';
import SpotHeroLogo from '@spothero/icons/spothero';

import * as styles from './SplashScreen.styles';
import defaultBackground from './utils/default-background';

const SplashScreen = () => (
    <Box
        role="alert"
        tabIndex={-1}
        {...styles.screen}
        aria-live="assertive"
        data-testid="SplashScreen"
        aria-label="Loading SpotHero's Control Panel"
    >
        <Box {...styles.roadMap(defaultBackground)} />
        <Box {...styles.loading}>
            <SpotHeroLogo />
            <Heading as="h1" {...styles.heading} tabIndex={-1}>
                Control Panel
            </Heading>
            <Spinner {...styles.spinner} />
        </Box>
    </Box>
);

export default SplashScreen;
